module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-3"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "chapter-3-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Chapter 3")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-3-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("O")]), _vm._v("n the bus Monday morning, everyone wore earphones as usual, listening to music, playing games, and checking out Tinder. The temperature? Twenty-eight degrees with a top of thirty-seven forecast. It was going to be a stinker. Most faces looked hot, irritable and sweaty. Maybe because of Tinder, most likely because of the weather.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("An advertisement on the wall panel above one of the windows showed a pristine sandy beach, rolling waves and cloudless blue sky. "), _c('i', [_vm._v("Escape to the south coast where the sun shines, sand sparkles and the beach beckons. What are you waiting for?")]), _vm._v(" It seemed directly aimed at me.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("What are you waiting for? ")]), _vm._v("My job, that’s what. I had a job to do. A job I was very good at. Even if I was pissed off.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Coffee in hand, I was seated at my desk by seven forty-five. As I sorted through emails, a new one arrived from Alastair to Glenn, copying me and the rest of the team. I read it and read it again. Several accounts were to be reshuffled. Mainly mine. Effective immediately.")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote-container prose without-attribution"
  }, [_c('blockquote', {
    staticClass: "prose without-attribution"
  }, [_c('p', {
    staticClass: "first blockquote-content blockquote-content-prose blockquote-position-first blockquote-position-last"
  }, [_c('span', {
    staticClass: "monospace"
  }, [_vm._v("As the new Operations Manager, Glenn Kelly would prefer a more hands-on role than the previous OM. Glenn will speak with you individually to ensure the smooth and efficient transfer of information … I am sure you will agree that this new direction is fresh and exciting and in the best interests of the company…")])])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Blah, blah, fucking blah.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Of my twelve accounts, three provided the majority of my bonuses. Taking them away effectively meant cutting my salary by a third. I stared at the email a bit longer, tapping my fingers on my desk.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Fight or flight?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("At a minute past eight, I cleared out my personal belongings. A framed photo of Trouble swimming in the bath, one of Matt and me from a Christmas party two years earlier, a motley African violet, some hair clips and my spare travel card. Not much to show for eight years. Everything but the plant fitted in my bag. I took a deep breath and walked out, handbag and plant in one hand, half-drunk coffee in the other.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("While I waited for the lift, guessing which one would arrive first, Taylor stepped out of elevator three and eyed me suspiciously. ‘What’s going on?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I shrugged, determined to remain calm. ‘Taking some time off.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You okay?’ Taylor looked bemused.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Talk to you later.’ I handed her my plant and stepped into the lift.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Out on the street, I fished Trish’s card out of my bag and phoned her. She answered after two rings.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘It’s Lily Mason calling. Is the butcher shop still for rent?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Lily, how nice to hear from you so soon. Sure is.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Good, I’ll take it.’ I’d sort out the details later.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("After I’d hung up, Taylor rang. ‘At the risk of repeating myself, what’s going on?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m quitting, getting drunk, moving to the beach and opening a flower shop.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Yeah, okay. What’s really going on? Glenn pissing you off already?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You wouldn’t be laughing if you had to report to him.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘No, I wouldn’t. I’ll stick with Human Resources, thanks. So, what’s up?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I told you.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘A flower shop, just like that?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘It would appear so.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("An hour later, after another coffee and a big breakfast of avocado and tomato on sourdough, I returned to the office, got an audience with Alastair, and resigned.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I understand your position, Lily—’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I rolled my eyes. ‘On Friday, you said nothing would change. For crying out loud, Alastair, I’ve lost viable accounts and it’s only…’ I made a point of checking my Fitbit ‘…Nine-fifteen. Monday morning.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I wish you’d reconsider.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Why? I’ve lost a third of my business and he has zero respect for his female colleagues.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Alastair stared at me. ‘I give you my word I’ll be keeping close tabs on him.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Your word doesn’t mean much, given our previous conversation. Besides, I don’t want to work under Glenn.’ I took a moment to calm down and breathe. ‘Give me a reason to stay. Tell me you’ll let me keep my accounts.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I knew it. ‘I rest my case.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Thankfully, Alastair let me take my entitlements. Accounts took all of fifteen minutes to present me with my final pay statement. I was home just after ten thirty.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Aunty Iris,’ I said, when she answered her phone. ‘I’ve done it.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Done what, darl?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Resigned. I’ve spoken with Trish. The butcher’s shop is mine.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Pardon?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m opening a florist shop.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Wow, you move fast when you set your mind to something.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I hesitated. ‘Do you think I’ve done the wrong thing?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Good heavens, no! Lily-Pily, I knew the corporate world couldn’t hold you captive forever. You and I are simpatico. We’re flower girls … we need to be free with our blooms.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Er, yes. I guess.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Just know that unlike finance and business, running a flower shop will never make you millions. But you’ll be rewarded in so many ways you’d never expect.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She’d said much the same to me when I’d enrolled for the floristry diploma. At the time, her words led me to choose a career in finance. This time, I wouldn’t be swayed. ‘Better to live the dream and be poor than to never give it a go.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘That’s the spirit, my girl. And at Clearwater! A mere fifteen minutes’ drive from me. You are one lucky lady. I can be at your beck and call when I’m not scouring the flea markets, playing bingo or napping. Now then,’ she said, suddenly serious, ‘what did your mother say? I can almost hear her screams from here.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Let’s keep this conversation secret until the lease is signed. But all going well, I’ll be moving down early January.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Two hours later, Trish emailed me the preliminary contract, which included terms and conditions, the dimensions of the shop, renter expectations and the owner and real estate agent obligations. Straightforward.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("My heart screamed ‘YES’, but my business head wasn’t so sure. I’d always been so careful … there was an option to sign for six or twelve months. I closed my eyes. This was my chance. Blinking, I signed for twelve months.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Holy Fuck!")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I’d avoided Matt all weekend. Perhaps "), _c('i', [_vm._v("avoided")]), _vm._v(" was too strong a word. We spoke and texted, but I hadn’t seen him since Saturday morning. He knew I was pissed off but didn’t know I was about to completely uproot my life. The sooner I could tell him and clear the air, the better. Or so I hoped. We needed a proper conversation and Monday date night was the time. I heated up a beef lasagne from the local deli, made a green salad, opened a bottle of Shiraz, and waited for Matt to arrive.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Seven o’clock came and went. Sick of tapping my fingers and talking to Trouble, I poured myself a glass.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A text came through at seven twenty.")]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-left"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('span', {
    staticClass: "sans-serif"
  }, [_vm._v("Sorry, babe. Still in a meeting. Should be there by nine. Please wait up. X")])])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I drained a second glass and picked at a piece of lasagne while Trouble ate my salad. At nine, I covered what I hadn’t eaten with plastic wrap and put it in the fridge. I placed the leftover wine on a side bench, put Trouble in his hutch and went to bed. So much for having a heart to heart.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Sometime later, Matt crept into the bedroom. ‘Hey,’ he whispered, climbing in beside me.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘We need to talk,’ I said, sitting up, instantly awake.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Can it wait till morning? I’m knackered.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I took a deep breath and lay back down. We were both shattered. Yes, our talk could wait till morning.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Ten minutes later, after thrashing about and getting even more agitated, I poked him in the ribs. ‘I’ve quit my job and I’m opening a flower shop on the coast.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Ha.’ He patted my head, half asleep. ‘Good one, Lil.’")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-141"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/break-hedera-side-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("At five am, my alarm beeped. I hit the snooze button.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Matt reached over. ‘Was I dreaming last night when you said something about flowers?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You still haven’t said what you would’ve done, had I got the promotion.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Does it matter?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘To me? Yes.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Matt shook his head. ‘I don’t know. This transfer is a promotion. It means a lot to me.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I nodded. ‘As did mine, to me. So, I’ve been doing some thinking. I’m like one of those mice in a spinning wheel, running all the time, exhausted, but never moving forward. Just going around in circles.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m confused.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m not happy. I haven’t been properly fulfilled for a while but I’ve been too busy and worn out to notice.’ I rubbed my tired face. ‘So,’ I yawned, ‘I’ve taken out a lease on the old butcher shop in Clearwater.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Matt was awake now. He took his hand in mine. ‘Please tell me you haven’t really done this?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’ve left the company. I couldn’t stay after what happened. There’s no way I can report to Glenn. He’s a misogynist.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘How could you make that decision without me?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Pardon? You made a decision to relocate to Singapore without me.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘It’s not the same.’ He dropped my hand. ‘My choice includes you. I was thinking about our future.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘No. You’re thinking about "), _c('i', [_vm._v("your f")]), _vm._v("uture. I’m thinking about mine.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He climbed out of bed, clearly annoyed. ‘What does this mean for us?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I got out of bed too. ‘There’s still an "), _c('i', [_vm._v("us")]), _vm._v(", Matty. But I need to do something for myself.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I want you to come to Singapore with me.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I shook my head. ‘I can’t.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You on the coast? You’ll be bored and lonely.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I shrugged. ‘Maybe.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘And we’ll be apart.’ He was frowning. ‘Why can’t you at least give Singapore a go? You could get a job there. How about working for a multinational based in Asia?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I can’t. A working visa would take months. Besides the company would have to sponsor me.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘There are charities crying out for volunteers. I’m sure you could work with animals. You’ve always wanted to do that—’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘In Australia!’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Freelance from home then?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘What home? I’m sorry but it’s not what I want to do.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘And opening a florist’s is?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Yes.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I don’t believe you. When is all this happening?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘January.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He shook his head. ‘Madness. You’ll be fed up in a couple of months, missing me terribly and longing to join me in Singapore.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Maybe.’ I loved Matt, but events over the past few days had forced me to confront uncomfortable facts. I didn’t want to live in Singapore. I didn’t want to report to Glenn. I needed to focus on my ambitions, my dreams, and I was under no illusion it would be easy.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-797ac1cd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-003.vue
// module id = 81
// module chunks = 0